const getRankTileDataFields = () => {
  return [
    //big number
    {
      title: "Metrics",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    //date x
    {
      title: "Name",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Rank",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 1,
      valueType: "Number",
      canEdit: true,
    },
  ];
};

const getRankTileCustomizationFields = () => {
  return [
    {
      title: "Image",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isIconVisible",
      innerComponents: [
        {
          title: "Icon",
          type: "imageUpload",
          reduxKey: "imageUrl",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Image Width",
          type: "range",
          reduxKey: "imageWidth",
          defaultValue: 10,
          minValue: 10,
          maxValue: 100,
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
      ],
    },
    //without toggle
    //font
    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isLabelVisible",
      innerComponents: [
        {
          title: "Label",
          type: "text",
          defaultValue: "your text here...",
          minValue: 0,
          maxValue: 20,
          reduxKey: "label",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Label Size",
          type: "range",
          defaultValue: 92,
          minValue: 10,
          maxValue: 100,
          reduxKey: "labelFontSize",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Label Color",
          type: "fontColor",
          reduxKey: "labelFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
          defaultValue: "#bababa",
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: true,
          reduxKey: "isLabelBold",
          isParent: true,
        },
        {
          title: "Label Alignment",
          type: "SELECT_BOX",
          reduxKey: "labelAlignment",
          options: [
            { label: "Top", value: "top" },
            { label: "Center", value: "center" },
            { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Top", value: "top" },
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },
    {
      title: "Value",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isNumberVisible",
      innerComponents: [
        {
          title: "Color",
          type: "fontColor",
          reduxKey: "numberFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
          defaultValue: "#bababa",
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: false,
          reduxKey: "isNumberBold",
          isParent: true,
        },
        {
          title: "Size",
          type: "range",
          reduxKey: "numberFontSize",
          defaultValue: 70,
          minValue: 10,
          maxValue: 100,
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
      ],
    },

    //rank
    {
      title: "Name",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isRanknameVisible",
      innerComponents: [
        {
          title: "Color",
          type: "fontColor",
          reduxKey: "rankFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          defaultValue: "#bababa",
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: true,
          reduxKey: "isRankBold",
          isParent: true,
        },
        {
          title: "Size",
          type: "range",
          defaultValue: 100,
          minValue: 10,
          maxValue: 100,
          reduxKey: "rankFontSize",
          isParent: true,
        },
        {
          title: "Alignment",
          type: "SELECT_BOX",
          reduxKey: "rankAlignment",
          options: [
            { label: "Top", value: "top" },
            { label: "Center", value: "center" },
            { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Center", value: "center" },
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },
  ];
};

export { getRankTileDataFields, getRankTileCustomizationFields };
